<app-header></app-header>

<app-alert-loading [statusUpload]="statusUploadApi" [statusFase]="statusFaseApi" [alertLoading]="showModal == 'AlertLoading'" sourceScreen="importacao-realizacao-pedidos:home"></app-alert-loading>
<app-alert-resumo-importacao [alertResumoImportacao]="showModal == 'AlertResumoImportacao'" [resumoImportacao]="dadosResumoImportacao" (alertResumoImportacaoFechou)="eventoAlertResumoImportacao($event)" sourceScreen="importacao-realizacao-pedidos:resumo-de-importacao" screenType="modal"></app-alert-resumo-importacao>
<app-alert-sucesso [alertSucesso]="showModal == 'AlertSucesso'" [alertSucessoSubtitulo]="tituloAlertSucesso" [alertSucessoMensagem]="substituloAlertSucesso" (alertSucessoFechou)="eventoAlertSucesso($event)" (alertSucessoAvancou)="alertSucessoAvancou()" sourceScreen="importacao-realizacao-pedidos:importacao-realizada"></app-alert-sucesso>
<app-alert-erro [alertErro]="showModal == 'AlertErro'" [mensagemErro]="mensagemErroApi" (alertErroFechou)="eventoAlertErro($event)" sourceScreen="importacao-realizacao-pedidos:erro-de-importacao"></app-alert-erro>
<app-alert-erro-dados [alertErroDados]="showModal == 'AlertErroDados'" (alertIgnorarDadosFechou)="eventoAlertIgnorarDados($event)"></app-alert-erro-dados>
<app-alert-inconsistencias [alertInconsistencia]="showModal == 'AlertInconsistencia'" [mensagemInconsistencia]="mensagemInconsistenciaApi" (alertInconsistenciaFechou)="eventoAlertInconsistencia($event)"></app-alert-inconsistencias>
<app-loading-generico [loadingGenerico]="showModal == 'LoadingGenerico'"></app-loading-generico>
<app-alert-generico
  [message]="modalUploadingFile.message"
  [type]="modalUploadingFile.type"
  [buttons]="modalUploadingFile.buttons"
  [show]="showModal == 'UploadingFile'"
[description]="modalUploadingFile.description"></app-alert-generico>

<app-alert-recarga-certa (alertRecargaCertaFechou)="eventoAlertRecargaCerta($event)" [alertRecargaCerta]="alertRecargaCerta" > </app-alert-recarga-certa>
<app-botao-chat></app-botao-chat>

<app-alert-erro-customizado [alertErro]="showAlertErro" [alertErroBotao]='"FECHAR"' [alertErroTitulo]="tituloErroApi" [alertErroMensagem]="mensagemErroApi" (alertErroFechou)="eventoAlertErroImportacao()"></app-alert-erro-customizado>

<div class="container py-4">
  <!-- ALERTA DE INCONSISTÊNCIA -->
  @if (avisoInconsistencia) {
    <div class="row mb-3">
      <div class="col-12">
        <div class="card-inconsistencia">
          <i class="fa fa-exclamation-circle c-warning float-start mt-3 icone-grande" aria-hidden="true"></i>
          <h3 class="titulo-alert-inconsistencia ms-5">:/ Seu último Upload foi realizado com inconsistências</h3>
          <p class="descricao-alert-inconsistencia ms-5">Caso deseja prosseguir com a importação você precisa tratar alguns problemas encontrados. <span class="link-alert-warning" routerLink="/tratativas">Clique aqui para tratar e avançar para os próximos passos.</span></p>
        </div>
      </div>
    </div>
  }
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-12 col-lg-8 mb-4 mb-lg-0">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Realizar pedidos</h1>
        <h4 class="paragrafo-card mb-5">Aqui você deverá realizar os pedidos da sua empresa através de uma nova importação ou última base importada.</h4>
        <div class="row">
          <div class="col-12 col-md-6 mb-4">
            <div class="opcao-ativa" [tag]="addTagManagerInteraction('card:box:click', 'importar-dados')">
              <h5 class="titulo-card-opcoes">
                <img src="/assets/img/dados.png" class="imagens-card-opcoes" alt="dados">
              IMPORTAR DADOS / FAZER PEDIDOS</h5>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-4">
            <button
              class="opcao bg-transparent w-100"
              id="btnFazerPedidoBaseAtual"
              [tag]="addTagManagerInteraction('card:box:click', 'fazer-pedido-com-base-atual')"
              (click)="navigateToFazerPedidoIntegral()"
              >
              <h5 class="titulo-card-opcoes">
                <img src="/assets/img/base-atual.png" class="imagens-card-opcoes" alt="base atual">
                FAZER PEDIDO COM BASE ATUAL
              </h5>
            </button>
          </div>
        </div>
        <!-- TIPO DO CÓDIGO -->
        <div class="mb-4">
          <label class="label" for="slctTipoArquivoBeneficios">TIPO ARQUIVO DE BENEFÍCIOS</label>
          <app-select [value]="tipoCodigoBeneficio" (valueChanges)="tipoCodigoBeneficio = $event"
            name="tipoCodigoBeneficionName"
            id="slctTipoArquivoBeneficios"
                            [options]="[
                            {name : 'Código do fornecedor - Cod. Venda Alelo' , value : 'F'} ,
                            {name : 'Código do fornecedor - VB' , value : 'V'} ,
                            {name : 'Código do fornecedor - Ticket' , value : 'T'}
                            ]"
            optionValue="value" optionText="name"
            [tag]="addTagManagerInteraction('select:dropdown:click', 'codigo-fornecedor-alelo')"
            >
          </app-select>
        </div>
        <div class="row">
          <!-- PEDIDO COM RECARGA CERTA -->
          <div class="col-12 col-lg-4">
            <div class="mb-2">
              <span class="label">PEDIDO COM RECARGA CERTA?</span>
            </div>
            <div>
              <!-- Sem economia ou COM ECONOMIA -->
              <label class="label-customaziada" for="switchRecargaCerta">Não</label>
              <div class="form-check form-switch ms-38">
                <input [(ngModel)]="pedidoRecargaCerta" (change)='getDados()' type="checkbox" class="form-check-input" id="switchRecargaCerta"
                  [tag]="addTagManagerInteraction('select:toggle:click', 'pedido-com-recarga-certa')">
                <label class="form-check-label" for="switchRecargaCerta">Sim</label>
              </div>
            </div>
          </div>
          <!-- AJUSTE AUTOMATICO? -->
          <div class="col-12 col-lg-8">
            <div class="col-12 col-lg-12" style="display: inline-flex; margin-bottom: -5px;">
              <p class="label" style="width: 87%">
                AJUSTE AUTOMÁTICO DO VALOR MÍN/MÁX DA TARIFA?
              </p>

              <i
                class="fa fa-info-circle c-black fa-1x icone-padrao mt-50"
                aria-hidden="true"
                [popover]="myPopoverAjuste"
                popoverTitle="Ajuste Automático"
                popoverPlacement="top"
                triggers="click"
                [outsideClick]="true">
              </i>

              <ng-template #myPopoverAjuste>
                <span>
                  Ajuste de menor ou maior valor liberado para compra da operadora solicitada.
                </span>
              </ng-template>
            </div>
            <div class="col-12 col-lg-8">
              <label class="label-customaziada" for="switchAjusteAutomatico">Não</label>
              <div class="form-check form-switch ms-38">
                <input [(ngModel)]="ajusteAutomatico" type="checkbox" class="form-check-input" id="switchAjusteAutomatico"
                  [tag]="addTagManagerInteraction('select:toggle:click', 'ajuste-automatico')">
                <label class="form-check-label" for="switchAjusteAutomatico">Sim</label>
              </div>
            </div>

          </div>
        </div>

        <!-- Importador de arquivos, a parte que vai escolher o arquivo -->
        <div class="file-drop-area">
          <img src="/assets/img/upload-arquivo.png" width="40px" class="float-start me-3" alt="upload">
          <span class="fake-btn">{{nomeArquivo}}</span>
          <span class="file-msg">Arraste ou selecione o arquivo.<br>Formatos permitidos: {{allowedExtensions}}.<br>
            <strong
              class="verde">Não são permitidos caracteres especiais no nome e nome da mãe <br>do colaborador.</strong>
            </span>
            <form method="post" enctype="multipart/form-data">
              <input class="file-input" id="inputFile" type="file" accept="{{allowedExtensions}}" (change)="capturarArquivoAws($event)"
                [tag]="addTagManagerInteraction('box:button:click', 'selecionar-arquivo')">
            </form>
          </div>

          @if (!avisoInconsistencia) {
            <div>
              <button class="botao-outline me-3" id="botaoCancelar" (click)="cancelarCapturaArquivo()"
              [tag]="addTagManagerInteraction('box:button:click', 'cancelar')">CANCELAR</button>
              <button class="botao" (click)="enviarImportacaoAws()" id="botaoEnviarPedido"
                [disabled]="nomeArquivo == 'Selecionar arquivo' || !('PedidosImportarDadosFazerPedido' | usuarioPermissao:'Incluir' | async)"
                [ngClass]="{disabled: nomeArquivo == 'Selecionar arquivo' || !('PedidosImportarDadosFazerPedido' | usuarioPermissao:'Incluir' | async)}"
                [tag]="addTagManagerInteraction('box:button:click', 'enviar-pedido')"
              >ENVIAR PEDIDO</button>
            </div>
          }

          @if (avisoInconsistencia) {
            <div>
              <p class="legenda-erro mt-4">O último arquivo importado para este CNPJ apresenta inconsistências. <br>
                <span class="link-alert-warning" routerLink="/tratativas">Clique aqui para tratar e avançar para os próximos passos.</span>
              </p>
              <button class="botaoLongo mt-3 px-5" (click)="cancelarImportacao()">CANCELAR IMPORTAÇÃO</button>
            </div>
          }

        </div>
        <div class="card-painel-manutencoes mt-3" routerLink="/painel-manutencoes" [tag]="addTagManagerInteraction('card:banner:click', 'painel-de-manutencoes')">
          <img src="/assets/img/painel-manutencoes.png" width="50px" alt="manutencao" class="float-start me-2">
          <h4 class="titulo-painel-manutencoes">PAINEL DE MANUTENÇÕES</h4>
          <p class="paragrafo">Realize suas manutenções de endereço e produto</p>
        </div>
      </div>
      <!-- DIV LATERAL COM AS DICAS E INFORMAÇÕES E DOWNLOAD DE ARQUIVOS, apenas algo estático -->
      <div class="d-none d-lg-block col-lg-4">
        <img src="/assets/img/banner_rc.jpg" class="mb-3 rounded" width="100%" alt="propaganda">
        <app-lateral-importador-pedidos></app-lateral-importador-pedidos>
      </div>

      <!-- ÚLTIMAS IMPORTAÇÕES TABLEA -->
      <div class="col-12 mt-3">
        <div class="card">
          <button class="botao-outline-historico float-end" id="btnHistoricoImportacao" routerLink="/historico-importacoes"
          [tag]="addTagManagerInteraction('box:button:click', 'historico-de-importacoes')">HISTÓRICO DE IMPORTAÇÕES</button>
          <h3 class="titulo-ultimas-importacoes">Últimas importações</h3>
          <h4 class="paragrafo-card mb-3">Dados das últimas importações realizadas</h4>

          <!-- TABELA -->
          @if (historicoImportacao) {
            <table class="table table-hover border-bottom" aria-describedby="tabela de historico de importacoes">
              <thead>
                <tr>
                  <th scope="col">DATA</th>
                  <th scope="col">HORÁRIO</th>
                  <th scope="col">SITUAÇÃO</th>
                  <th scope="col">FASE</th>
                  <th scope="col">TIPO DO ARQUIVO</th>
                  <th>DOWNLOAD</th>
                  <th scope="col">ERRO</th>
                </tr>
              </thead>
              <tbody>
                <!-- LINHA 1 -->
                @for (importacao of historicoImportacao; track importacao) {
                  <tr>
                    <td>{{importacao.dataImportacao.slice(0,10)}}</td>
                    <td>{{importacao.dataImportacao.slice(11,16)}}</td>
                    @if (importacao.descricaoStatus == 'FINALIZADO') {
                      <td>Importação concluída</td>
                    }
                    @if (importacao.descricaoStatus != 'FINALIZADO' && importacao.descricaoStatus != 'CANCELADO PELO USUÁRIO') {
                      <td>Importação concluída com problemas</td>
                    }
                    @if (importacao.descricaoStatus == 'CANCELADO PELO USUÁRIO') {
                      <td>Importação cancelada pelo usuário</td>
                    }
                    <td>{{importacao.descricaoFase | camelCase}}</td>
                    <td>{{importacao.descricaoTipoArquivoImportacao}}</td>
                    <td class="text-center">
                      <button
                        (click)="downloadImportacao(importacao)"
                        id="btnDownloadPedido{{importacao.idImportacao}}"
                        [tag]="addTagManagerInteraction('select:icon:click', 'download')"
                        style="background: none; border: none; padding: 0; margin: 0; cursor: pointer; outline: none; display: inline-flex; align-items: center; color: inherit; font-size: inherit;"
                        >
                        <i class="fa fa-download c-primary" aria-hidden="true"></i>
                      </button>
                    </td>
                    @if (importacao.contemInconsistencias == true) {
                      <td class="text-center">
                        <button
                          (click)="downloadErrosImportacao(importacao.idImportacao)"
                          id="btnDownloadErrosImportacao{{importacao.idImportacao}}"
                          [tag]="addTagManagerInteraction('select:icon:click', 'erro')"
                          style="background: none; border: none; padding: 0; margin: 0; cursor: pointer; outline: none; display: inline-flex; align-items: center; color: inherit; font-size: inherit;"
                          >
                          <i class="fa fa-download c-primary" aria-hidden="true"></i>
                        </button>
                      </td>
                    }
                    @if (importacao.contemInconsistencias != true) {
                      <td></td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          }

          <!-- LOADING DO HISTORICO DE IMPORTAÇÕES -->
          @if (historicoImportacao === null) {
            <div class="w-100 mt-4">
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando histórico de importações ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando histórico de importações ...</p>
            </div>
          }
          <!-- QUANDO DER ERRO -->
          @if (historicoImportacao === false) {
            <div class="w-100 mt-4 text-center">
              <img src="/assets/img/erro.png" alt="erro" width="230px">
              <p class="legenda-erro">Ocorreu um erro na consulta do histórico de importações.</p>
            </div>
          }
          @if (historicoImportacao === undefined) {
            <div class="text-center">
              <img src="/assets/img/vazio.png" alt="nao possui importacoes" width="230px">
              <p class="legenda-vazio">Você ainda não possui importações.</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
